import http from "./axios";

// 查询引导图片
export const paySuccessPosterUrl = ({ orderId }) => {
  return http.get("/product/getPaySuccessPosterUrl", {
    orderId: orderId,
  });
};
